export default __webpack_public_path__ + "static/media/stock-icon-black.39208553.svg";